import * as React from "react";
import C from "classnames";
export const CardHeader = (props) => {
    return (React.createElement("div", { className: C("card-header", props.autoMargin && "mr-auto", props.className), "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=CardHeader.js.map